import { MENU_LIST, SUB_MENU } from "./menu"

export const INFO = {
  MENU: MENU_LIST,
  SUB_MENU: SUB_MENU,
}


